import { PatientInfoGroups } from '../enums/patient-info-groups.enum';

export const PatientInfoGroupOrder = {
  [PatientInfoGroups.PRIMARY]: 0,
  [PatientInfoGroups.SECONDARY]: 1,
  [PatientInfoGroups.CONTACT]: 2
};
